export default "__VITE_ASSET__BAYXICC7__"